// extracted by css-extract-rspack-plugin
export default {"passwordHide":"src-components-UI-PasswordHide-module__passwordHide-SA9Wu3"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"passwordHide\":\"src-components-UI-PasswordHide-module__passwordHide-SA9Wu3\"}";
        // 1791855167225
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  